module.exports = __webpack_public_path__ + "img/FallaDisco.fe128b84.svg";